import React from 'react';
import './PaymentReturnPage.css';
import AppHeader from './AppHeader';

function PaymentReturnPage({ status, onGoHome, showTelegramLink = false, miniAppLink = '' }) {
  const handleClick = () => {
    if (onGoHome) onGoHome();
  };

  if (status === 'loading' || status === null) {
    return (
      <div className="app">
        <div className="background"></div>
        <AppHeader title="Rocket VPN" />
        <div className="content payment-return-content payment-return-loading">
          <div className="payment-return-spinner"></div>
          <p className="payment-return-message">Проверка платежа…</p>
          <button type="button" className="subscription-selection-pay-button payment-return-button" onClick={handleClick}>
            На главную
          </button>
          {showTelegramLink && miniAppLink && (
            <a href={miniAppLink} target="_blank" rel="noopener noreferrer" className="payment-return-telegram-link">
              Вернуться в бот
            </a>
          )}
        </div>
      </div>
    );
  }

  if (status === 'succeeded') {
    return (
      <div className="app">
        <div className="background"></div>
        <AppHeader title="Rocket VPN" />
        <div className="content payment-return-content payment-return-success">
          <div className="payment-return-icon payment-return-icon-success">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </div>
          <p className="payment-return-message">Оплата прошла успешно</p>
          <p className="payment-return-sub">Подписка активирована. Вернитесь в Telegram-бота Rocket VPN, чтобы продолжить.</p>
          <button type="button" className="subscription-selection-pay-button payment-return-button" onClick={handleClick}>
            На главную
          </button>
          {showTelegramLink && miniAppLink && (
            <a href={miniAppLink} target="_blank" rel="noopener noreferrer" className="payment-return-telegram-link">
              Вернуться в бот
            </a>
          )}
        </div>
      </div>
    );
  }

  if (status === 'canceled') {
    return (
      <div className="app">
        <div className="background"></div>
        <AppHeader title="Rocket VPN" />
        <div className="content payment-return-content payment-return-canceled">
          <div className="payment-return-icon payment-return-icon-canceled">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
          <p className="payment-return-message">Оплата не прошла или отменена</p>
          <p className="payment-return-sub">Вы можете попробовать оплатить снова с главной страницы.</p>
          <button type="button" className="subscription-selection-pay-button payment-return-button" onClick={handleClick}>
            На главную
          </button>
          {showTelegramLink && miniAppLink && (
            <a href={miniAppLink} target="_blank" rel="noopener noreferrer" className="payment-return-telegram-link">
              Вернуться в бот
            </a>
          )}
        </div>
      </div>
    );
  }

  if (status === 'pending') {
    return (
      <div className="app">
        <div className="background"></div>
        <AppHeader title="Rocket VPN" />
        <div className="content payment-return-content payment-return-pending">
          <div className="payment-return-icon payment-return-icon-pending">
            <div className="payment-return-spinner payment-return-spinner-blue" />
          </div>
          <p className="payment-return-message">Оплата в статусе ожидания</p>
          <p className="payment-return-sub">Подождите несколько минут и обновите страницу — подписка будет активирована после завершения оплаты. Если прошло много времени — проверьте статус в профиле или обратитесь в поддержку.</p>
          <button type="button" className="subscription-selection-pay-button payment-return-button" onClick={handleClick}>
            На главную
          </button>
          {showTelegramLink && miniAppLink && (
            <a href={miniAppLink} target="_blank" rel="noopener noreferrer" className="payment-return-telegram-link">
              Вернуться в бот
            </a>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <div className="background"></div>
      <AppHeader title="Rocket VPN" />
      <div className="content payment-return-content payment-return-unknown">
        <div className="payment-return-icon payment-return-icon-unknown">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
        </div>
        <p className="payment-return-message">Не удалось определить статус платежа</p>
        <p className="payment-return-sub">Подписка может быть неактивна — проверьте в профиле или попробуйте оплатить снова.</p>
        <button type="button" className="subscription-selection-pay-button payment-return-button" onClick={handleClick}>
          На главную
        </button>
        {showTelegramLink && miniAppLink && (
          <a href={miniAppLink} target="_blank" rel="noopener noreferrer" className="payment-return-telegram-link">
            Вернуться в бот
          </a>
        )}
      </div>
    </div>
  );
}

export default PaymentReturnPage;
